exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share__share-overlay__5AegS{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex-direction:column;flex-direction:column;height:100%}.share__title__nxMOB{font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration;margin-bottom:20px;font-size:18px}@media (max-width:549px){.share__title__nxMOB{font-size:14px;margin:13px 0 0}}.share__social-icons__3Hnvy{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:325px}.share__share-icon__2WNxR{color:#fff;height:60px;font-size:38px;text-decoration:none}@media (max-width:549px){.share__share-icon__2WNxR{font-size:20px}}.share__share-link__njEdF{padding-left:20px;padding-right:20px}@media (max-width:549px){.share__share-link__njEdF{padding-left:11px;padding-right:11px}}.share__link__1GT2s:hover{color:-wix-colors-buttonsAndLinksColor}[data-layout=\"3\"] .share__link__1GT2s:hover{color:hsla(0,0%,100%,.5)}.share__tumblr__3QwFD:hover{color:#34465d}.share__pinterest__13EtM:hover{color:#bd081c}.share__facebook__2Pncv:hover{color:#3b5999}.share__twitter__OTnWt:hover{color:#55acee}[data-layout=\"3\"] .share__popout-outer__1HfHw{width:222px}[data-layout=\"3\"] .share__popout-inner__2_a9Z:hover{color:#000}", ""]);

// exports
exports.locals = {
	"share-overlay": "share__share-overlay__5AegS",
	"shareOverlay": "share__share-overlay__5AegS",
	"title": "share__title__nxMOB",
	"social-icons": "share__social-icons__3Hnvy",
	"socialIcons": "share__social-icons__3Hnvy",
	"share-icon": "share__share-icon__2WNxR",
	"shareIcon": "share__share-icon__2WNxR",
	"share-link": "share__share-link__njEdF",
	"shareLink": "share__share-link__njEdF",
	"link": "share__link__1GT2s",
	"tumblr": "share__tumblr__3QwFD",
	"pinterest": "share__pinterest__13EtM",
	"facebook": "share__facebook__2Pncv",
	"twitter": "share__twitter__OTnWt",
	"popout-outer": "share__popout-outer__1HfHw",
	"popoutOuter": "share__popout-outer__1HfHw",
	"popout-inner": "share__popout-inner__2_a9Z",
	"popoutInner": "share__popout-inner__2_a9Z"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/player/info-overlay/share/share.styl
// module id = 1311
// module chunks = 0 1 2 3